import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../http/endpoints";

import { getStoredAuthToken } from "@util/auth";

const USER_KEY = ["user"];

const useCurrentUser = () => {
  return useQuery({
    queryKey: USER_KEY,
    queryFn: () => getUser(),
    refetchOnWindowFocus: false,
    // Disable query on public pages
    enabled: !!getStoredAuthToken(),
  });
};

export default useCurrentUser;
